var toCompactArray = function toCompactArray() {
  var _ref;

  return (_ref = []).concat.apply(_ref, arguments).filter(Boolean);
};

export default toCompactArray;